/// <reference path="../../../../typings/index.d.ts" />
///<reference path="../short-cuts/models/short-cuts-state-manager.controller.ts"/>

module Meevo.Components.Goals {
    'use strict';

    import IGoalColumn = Meevo.Components.Goals.IGoalColumn;
    import IGoalRowLine = Meevo.Components.Goals.IGoalRowLine;
    import IGoalRowModel = Meevo.Components.Goals.IGoalRowModel;
    import IShortCutsService = Meevo.Components.ShortCuts.IShortCutsService;
    import ShortCutsStateManagerController = Meevo.Components.ShortCuts.ShortCutsStateManagerController;
    import MaintenanceFormState = Meevo.Model.MaintenanceFormState;

    export enum GoalInputTypeEnum {
        Currency = 0,
        Percentage,
        Numeric,
        Float
    }

    export enum GoalDateRangeEnum {
        SpecificYear = 0,
        Today = 1,
        Yesterday = 2,
        Tomorrow = 3,
        ThisWeek = 4,
        LastWeek = 5,
        LastMonth = 6,
        ThisMonth = 7,
        NextMonth = 8,
        YearToDate = 9,
        LastTwelveMonths = 10
    }

    export enum GoalCategoryEnum {
        AverageRetailTicket = 30317, // not use
        AverageServiceTicket = 30316, // Average Ticket
        AverageTicket = 30301, // not use
        FrequencyOfVisit = 30312,
        NewClientsPerMonth = 30311,
        Rebook = 30313,
        NewClientRetention = 30314, // Retention
        RepeatClientRetention = 30315, // not use
        Retail = 30310,
        Service = 30309,
        Rating = 30560,
        RequestRate = 30561,
        Membership = 30585,
        Productivity = 30586,
        GiftCard = 11045085,
    }

    export enum GoalViewEnum {
        Default = 0,
        ActualForThisYear = 1,
        ActualForLastYear = 2
    }

    export interface IGoalBaseCriteria {
        itemsPerPage?: number,
        pageNumber?: number,
        criteria: {
            departmentIds?: Array<any>;
            employeeIds?: Array<any>;
            departmentId?: any;
            year: number;
            goalCategories: Object;
            view: any;
        }
    }

    export abstract class GoalBaseController extends ShortCutsStateManagerController {
        static $inject = [
            '$scope',
            '$rootScope',
            '$state',
            '$q',
            '$timeout',
            '$translate',
            '$locale',
            'meevo.AppSettings',
            'meevo.components.common.DataService',
            'meevo.components.modal.ModalService',
            'meevo.components.busy.BusyService',
            'meevo.components.common.SecurityService',
            'meevo.components.tracking.TrackingService',
            'meevo.components.common.IdentityService',
            'meevo.components.short-cuts.ShortCutsService'
        ];

        public showEdit: boolean = true;
        public isReadonly: boolean = true;

        public measurement: number;
        public isShowMeasurement: boolean = true;
        public isShowWorkingDays: boolean = true;
        public isShowActual: boolean = false;
        public isCountTotal: boolean = true;
        public baseCurrencyMaxValue: number = 99999;
        public currentYear = new Date().getFullYear();
        public currentMonth = new Date().getMonth() + 1; // Meevo month 1-12, js Date month 0-11
        public currencySymbol = this.$locale.NUMBER_FORMATS.CURRENCY_SYM;

        public departmentList: any = [];
        public departmentId: any = 0;
        public departmentIdsList = [];

        public employee: any;
        public employeesList: any = [];
        public employeeIdsList: any = [];

        public goalRowList: any;
        public goalRowArray: any;
        public backupGoalList: any;
        public isRequestAllowed: boolean = false;
        public goalCategory: GoalCategoryEnum;

        public setItemTitle(item, itemRow) {
        };

        public changeItemColumn(itemRow) {
        };

        public changeTotalCallback(itemRow) {
        };

        public filterCriteria: IGoalBaseCriteria;
        public hideFilters: boolean = false;

        public locationStartYear: any;
        public _yearSelect: any = [];

        public _categorySelect = [
            {
                id: GoalCategoryEnum.AverageServiceTicket,
                label: 'LABEL_AVERAGE_TICKET'
            },
            {
                id: GoalCategoryEnum.FrequencyOfVisit,
                label: 'LABEL_FREQUENCY_OF_VISIT'
            },
            {
                id: GoalCategoryEnum.NewClientsPerMonth,
                label: 'LABEL_NEW_CLIENTS_PER_MONTH'
            },
            {
                id: GoalCategoryEnum.Rebook,
                label: 'LABEL_REBOOK_GOALS'
            },
            {
                id: GoalCategoryEnum.Retail,
                label: 'LABEL_RETAIL'
            },
            {
                id: GoalCategoryEnum.NewClientRetention,
                label: 'LABEL_RETENTION'
            },
            {
                id: GoalCategoryEnum.Service,
                label: 'LABEL_SERVICE'
            },
            {
                id: GoalCategoryEnum.Rating,
                label: 'LABEL_5_STAR_RATING'
            },
            {
                id: GoalCategoryEnum.RequestRate,
                label: 'LABEL_REQUEST'
            },
            {
                id: GoalCategoryEnum.Membership,
                label: 'LABEL_MEMBERSHIP'
            },
            {
                id: GoalCategoryEnum.Productivity,
                label: 'LABEL_PRODUCTIVITY'
            },
            {
                id: GoalCategoryEnum.GiftCard,
                label: 'LABEL_GIFT_CARD_SALES'
            }
        ];

        public _measurementSelect = [
            {
                id: GoalInputTypeEnum.Currency,
                label: this.$translate.instant('LABEL_CURRENCY_AMOUNT', {currencySymbol: this.currencySymbol})
            },
            {
                id: GoalInputTypeEnum.Numeric,
                label: 'LABEL_UNITS'
            },
        ];

        public tableTitles: Array<any>;

        public titlesYear: Array<any> = [
            {
                id: 1,
                title: 'LABEL_MONTH_JANUARY'
            },
            {
                id: 2,
                title: 'LABEL_MONTH_FEBRUARY'
            },
            {
                id: 3,
                title: 'LABEL_MONTH_MARCH'
            },
            {
                id: 4,
                title: 'LABEL_MONTH_APRIL'
            },
            {
                id: 5,
                title: 'LABEL_MONTH_MAY'
            },
            {
                id: 6,
                title: 'LABEL_MONTH_JUNE'
            },
            {
                id: 7,
                title: 'LABEL_MONTH_JULY'
            },
            {
                id: 8,
                title: 'LABEL_MONTH_AUGUST'
            },
            {
                id: 9,
                title: 'LABEL_MONTH_SEPTEMBER'
            },
            {
                id: 10,
                title: 'LABEL_MONTH_OCTOBER'
            },
            {
                id: 11,
                title: 'LABEL_MONTH_NOVEMBER'
            },
            {
                id: 12,
                title: 'LABEL_MONTH_DECEMBER'
            },
            {
                id: 0,
                title: 'LABEL_TOTAL'
            },

        ];

        public titlesAverageTicket: Array<any> = [
            {
                id: 1,
                title: 'LABEL_AVERAGE_SERVICE_TICKET'
            },
            {
                id: 2,
                title: 'LABEL_AVERAGE_RETAIL_TICKET'
            },
            {
                id: 3,
                title: 'LABEL_AVERAGE_TICKET'
            },
        ];

        public titlesRetention: Array<any> = [
            {
                id: 1,
                title: 'LABEL_NEW_CLIENT_RETENTION'
            },
            {
                id: 2,
                title: 'LABEL_REPEAT_CLIENT_RETENTION'
            },
        ];

        public _showGoalsSelect = [
            {
                id: GoalViewEnum.Default,
                label: 'LABEL_GOALS_THIS_YEAR'
            },
            {
                id: GoalViewEnum.ActualForThisYear,
                label: 'LABEL_ACTUALS_THIS_YEAR'
            },
            {
                id: GoalViewEnum.ActualForLastYear,
                label: 'LABEL_ACTUALS_LAST_YEAR'
            }
        ];
        protected securityKeys = Meevo.Components.Common.SecurityKeys;
        public defaultEmployeeId: Guid = this.identityService.current().userAuthId;

        protected shortCutGroup: { [key: number]: IShortCutGroup };
        protected _mode: MaintenanceFormState;

        get mode() {
            return this._mode;
        }

        constructor(
            protected $scope: angular.IScope,
            protected $rootScope: ng.IRootScopeService,
            protected $state: angular.ui.IStateService,
            protected $q: angular.IQService,
            protected $timeout: angular.ITimeoutService,
            protected $translate: angular.translate.ITranslateService,
            protected $locale: angular.ILocaleService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected shortCutsService: IShortCutsService
        ) {
            super($scope, $state, shortCutsService);
            this.shortCutGroup = {};
            this._mode = MaintenanceFormState.Readonly;
            this.getYearList()
            this.init();
        }

        get isShowTableHeader() {
            return this.goalCategory === GoalCategoryEnum.FrequencyOfVisit
                || this.goalCategory === GoalCategoryEnum.Rebook
                || this.goalCategory === GoalCategoryEnum.RequestRate
                || this.goalCategory === GoalCategoryEnum.Productivity
        }

        init() {
        }

        /**
         * Saves the item currently being edited.
         */
        abstract save(): angular.IPromise<any>;

        /**
         * Close current tab
         * */
        closeContext(): void {
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state['current'], null);

            $('body').removeClass('goals-print');
        }

        /**
         * Edit button
         * */
        edit(): void {
            this.showEdit = false;
            this.isReadonly = false;
            this._mode = MaintenanceFormState.Editing;
        }

        /**
         * Cancel button
         * */
        cancel(): void {
            this.showEdit = true;
            this.isReadonly = true;
            this.goalRowList = this.formatGoals(angular.copy(this.backupGoalList));
            this._mode = MaintenanceFormState.Readonly;
        }

        get goalCategoryEnum(): any {
            return GoalCategoryEnum;
        }

        get inputNumericDecimalPart() {
            return this.getInputType() == GoalInputTypeEnum.Numeric ? 0 : 2;
        }

        /* Print */
        printGoals(): void {
            if ($('.goal-plugin').length) {
                $('body').addClass('goals-print');
                $('.goal-plugin__scrolled-section-wrap').scrollLeft(0);
            }

            window.print();
        }

        translateForPrint(point): string {
            let label;

            switch (point) {
                case 'category':
                    label = _.findWhere(this._categorySelect, {id: this.goalCategory}).label;
                    break;
                case 'measurement':
                    label = _.findWhere(this._measurementSelect, {id: this.measurement}).label;
                    break;
                case 'view':
                    label = _.findWhere(this._showGoalsSelect, {id: this.filterCriteria.criteria.view}).label;
                    break;
                case 'department':
                    label = this.departmentId ? _.findWhere(this.departmentList, {id: this.departmentId})['displayName'] : 'LABEL_GOAL_INFO_NONE';
                    break;
                case 'employee':
                    label = this.employee ? this.employee.displayName : 'LABEL_GOAL_INFO_NONE';
                    break;
            }

            return this.$translate.instant(label);
        }

        /**
         * Request for goals list
         */
        changeCriteriaFilter() {
        };

        changeMeasurement(): void {
            this.goalRowList = this.formatGoals(angular.copy(this.backupGoalList));
        }

        changeCategory(): void {
            this.changeCategoryCriteria();

            // Check show measurement
            if (this.goalCategory === GoalCategoryEnum.NewClientsPerMonth
                || this.goalCategory === GoalCategoryEnum.FrequencyOfVisit
                || this.goalCategory === GoalCategoryEnum.Rebook
                || this.goalCategory === GoalCategoryEnum.NewClientRetention
                || this.goalCategory === GoalCategoryEnum.AverageServiceTicket
                || this.goalCategory === GoalCategoryEnum.Rating
                || this.goalCategory === GoalCategoryEnum.RequestRate
                || this.goalCategory === GoalCategoryEnum.Membership
                || this.goalCategory === GoalCategoryEnum.Productivity
            ) {
                this.measurement = null;
                this.isShowMeasurement = false;
            } else {
                this.measurement = this.measurement || GoalInputTypeEnum.Currency;
                this.isShowMeasurement = true;
            }

            // Set table titles
            if (this.goalCategory === GoalCategoryEnum.NewClientsPerMonth
                || this.goalCategory === GoalCategoryEnum.Service
                || this.goalCategory === GoalCategoryEnum.Retail
                || this.goalCategory === GoalCategoryEnum.Rating
                || this.goalCategory === GoalCategoryEnum.Membership
                || this.goalCategory === GoalCategoryEnum.GiftCard
            ) {
                this.tableTitles = this.titlesYear;
            } else if (this.goalCategory === GoalCategoryEnum.AverageServiceTicket) {
                this.tableTitles = this.titlesAverageTicket;
            } else if (this.goalCategory === GoalCategoryEnum.NewClientRetention) {
                this.tableTitles = this.titlesRetention;
            }

            this.changeCriteriaFilter();
            this.isRequestAllowed = true;
        }

        changeCategoryCriteria(): void {
            let goalCategoriesList = [];

            if (!this.goalCategory) return;

            // Set goalCategory
            if (this.goalCategory === GoalCategoryEnum.AverageServiceTicket) {
                goalCategoriesList = [this.goalCategory, GoalCategoryEnum.AverageRetailTicket, GoalCategoryEnum.AverageTicket];
            } else if (this.goalCategory === GoalCategoryEnum.NewClientRetention) {
                goalCategoriesList = [this.goalCategory, GoalCategoryEnum.RepeatClientRetention];
            } else {
                goalCategoriesList = [this.goalCategory];
            }

            this.filterCriteria.criteria.goalCategories = goalCategoriesList;
        }

        changeView(): void {
            this.changeCriteriaFilter();

            this.isShowActual = this.filterCriteria.criteria.view !== GoalViewEnum.Default;
        }

        formatGoals(list: Array<any>) {
            if (!list) return;

            let data = {};
            let inputType = this.getInputType();

            list = _.sortBy(list, 'month');

            list.forEach((item: IGoalColumn) => {
                if (!item.id) {
                    item.id = 0;
                }

                if (!data[item.id]) {
                    data[item.id] = {
                        rows: []
                    };
                }

                if (!data[item.id]['rows'][item.year]) {
                    data[item.id]['rows'][item.year] = {
                        columns: []
                    };
                }

                this.setItemTitle(item, data[item.id].rows[item.year]);

                // Set value for view
                item.inputType = inputType;
                this.setValueView(item, this.isShowActual);

                // Calculate diff value and actualValue
                if (item.value) {
                    let value = item.value,
                        actualValue = item.actualValue;

                    item.diff = this.countDiff(value, actualValue);
                }

                if (this.goalCategory === GoalCategoryEnum.Service
                    || this.goalCategory === GoalCategoryEnum.Retail
                    || this.goalCategory === GoalCategoryEnum.NewClientsPerMonth
                    || this.goalCategory === GoalCategoryEnum.Rating
                    || this.goalCategory === GoalCategoryEnum.Membership
                    || this.goalCategory === GoalCategoryEnum.GiftCard
                ) {
                    // Month is columns
                    this.isShowWorkingDays = true;
                    this.isCountTotal = true;

                    if (item.month == 0) {
                        // Total
                        data[item.id]['rows'][item.year].total = item;
                    } else {
                        data[item.id]['rows'][item.year]['columns'][item.month] = item;
                    }

                    data[item.id].rows[item.year].total.workingDays += item.workingDays;

                } else {
                    this.isShowWorkingDays = false;
                    this.isCountTotal = false;

                    if (item.month !== 0) {
                        return;
                    }

                    data[item.id]['rows'][item.year]['columns'].push(item);
                }
            });

            if (this.isCountTotal) {
                this.countTotalGoalList(data);
            }

            return data;
        }

        // Get type input
        getInputType() {
            let inputType = GoalInputTypeEnum.Numeric;

            if (this.goalCategory === GoalCategoryEnum.Service
                || this.goalCategory === GoalCategoryEnum.Retail
                || this.goalCategory === GoalCategoryEnum.AverageServiceTicket
                || this.goalCategory === GoalCategoryEnum.GiftCard
            ) {
                inputType = GoalInputTypeEnum.Currency;
            } else if (this.goalCategory === GoalCategoryEnum.Rebook
                || this.goalCategory === GoalCategoryEnum.NewClientRetention
                || this.goalCategory === GoalCategoryEnum.RequestRate
                || this.goalCategory === GoalCategoryEnum.Productivity
            ) {
                inputType = GoalInputTypeEnum.Percentage;
            } else if (this.goalCategory === GoalCategoryEnum.Rating) {
                inputType = GoalInputTypeEnum.Float;
            }

            if (this.measurement) {
                inputType = this.measurement;
            }

            return inputType;
        }

        // Set value for view
        setValueView(item, isShowActual) {
            switch (item.inputType) {
                case GoalInputTypeEnum.Numeric:
                    item.value = item.unit;
                    item.maxValue = 99999;

                    if (item.goalCategory === GoalCategoryEnum.FrequencyOfVisit) {
                        item.value = item.amount;
                        item.maxValue = 999;
                    } else if (item.goalCategory === GoalCategoryEnum.NewClientsPerMonth) {
                        item.maxValue = 999;
                    }
                    break;

                case GoalInputTypeEnum.Currency:
                    item.value = item.amount;
                    item.maxValue = item.goalCategory === GoalCategoryEnum.AverageServiceTicket || item.goalCategory === GoalCategoryEnum.AverageRetailTicket || item.goalCategory === GoalCategoryEnum.AverageTicket ? 9999 : this.baseCurrencyMaxValue;
                    break;

                case GoalInputTypeEnum.Percentage:
                    item.value = item.percent;
                    item.maxValue = 100;
                    break;

                case GoalInputTypeEnum.Float:
                    item.value = item.amount;
                    item.maxValue = 5;
                    break;
            }


            if (isShowActual) {
                switch (item.inputType) {
                    case GoalInputTypeEnum.Numeric:
                        item.actualValue = item.actualUnit;

                        if (item.goalCategory === GoalCategoryEnum.FrequencyOfVisit) {
                            item.actualValue = item.actualAmount;
                        }
                        break;

                    case GoalInputTypeEnum.Currency:
                        item.actualValue = item.actualAmount;
                        break;

                    case GoalInputTypeEnum.Percentage:
                        item.actualValue = item.actualPercent;
                        break;

                    case GoalInputTypeEnum.Float:
                        if (typeof item.actualAmount !== 'undefined') {
                            item.actualValue = Number(item.actualAmount.toFixed(this.inputNumericDecimalPart));
                        }
                        break;
                }
            }
        }

        // Count Total
        countTotalGoalList(data) {

            _.forEach(data, (rowHolder: IGoalRowModel) => {
                if (!rowHolder) return;

                _.forEach(rowHolder.rows, (year: IGoalRowLine) => {
                    if (!year) return;

                    this.countTotal(year);

                });
            });
        }

        countTotal(itemRow) {
            let filledCount = 0;
            let filledActualCount = 0;
            itemRow.total.value = 0;
            itemRow.total.actualValue = 0;
            itemRow.total.maxValue = 0;
            itemRow.total.workingDays = 0;
            itemRow.columns.forEach((item) => {
                if (!item) return;
                if (itemRow.total.goalCategory === GoalCategoryEnum.NewClientsPerMonth) {
                    item.maxValue = 999;
                }

                // convert a from any "falsey" value to 0
                itemRow.total.actualValue += Number(item.actualValue) || 0;
                itemRow.total.value += Number(item.value) || 0;
                itemRow.total.workingDays += Number(item.workingDays) || 0;

                if (item.value && item.value > 0) {
                    filledCount++;
                }
                if (this.isShowActual && item.actualValue && item.actualValue > 0) {
                    filledActualCount++;
                }
                /*
                if (item.year > this.currentYear) {
                    itemRow.total.maxValue += Number(item.maxValue) || 0;
                } else if (item.year == this.currentYear) {
                    if (item.month < this.currentMonth) {
                        itemRow.total.maxValue += Number(item.value) || 0;
                    } else {
                        itemRow.total.maxValue += Number(item.maxValue) || 0;
                    }
                }*/
                itemRow.total.maxValue += Number(item.maxValue) || 0;
            });

            itemRow.total.value = parseFloat((itemRow.total.value).toFixed(this.inputNumericDecimalPart));

            if (itemRow.total.goalCategory === GoalCategoryEnum.Rating
                || itemRow.total.goalCategory === GoalCategoryEnum.NewClientsPerMonth
            ) {
                itemRow.total.value = filledCount ? parseFloat((itemRow.total.value / filledCount).toFixed(2)) : 0;
                itemRow.total.maxValue = itemRow.columns[1].maxValue;

                if (this.isShowActual && filledActualCount) {
                    itemRow.total.actualValue = parseFloat((itemRow.total.actualValue / filledActualCount).toFixed(2));
                }
            }
            this.countTotalDiff(itemRow);
        }

        countTotalPerDay(itemRow: IGoalRowLine) {
            let workingDaysLeft = 0;
            let totalValue = itemRow.total.value;
            let valuePerDay = 0;
            let numericDecimalPart = this.inputNumericDecimalPart;

            // Count working days and what total left
            itemRow.columns.forEach((column) => {
                if (column.year >= this.currentYear) {
                    workingDaysLeft += column.workingDays;
                } else {
                    totalValue -= parseFloat((column.value || 0).toFixed(numericDecimalPart));
                }
            });

            if (totalValue > 0 && workingDaysLeft > 0) {
                valuePerDay = totalValue / workingDaysLeft;
            }

            // set value for future month
            let iValue = itemRow.columns[1].year >= this.currentYear ? 1 : this.currentMonth;
            let maxValueAvailable = (12 - iValue) * itemRow.columns[1].maxValue;

            for (let i = iValue; i <= 12; i++) {
                if (totalValue >= maxValueAvailable) {
                    itemRow.columns[i].value = itemRow.columns[i].maxValue;
                } else {
                    if (itemRow.total.goalCategory === GoalCategoryEnum.Rating
                        || itemRow.total.goalCategory === GoalCategoryEnum.NewClientsPerMonth
                    ) {
                        itemRow.columns[i].value = itemRow.total.value;
                    } else {
                        itemRow.columns[i].value = parseFloat((valuePerDay * itemRow.columns[i].workingDays).toFixed(numericDecimalPart));
                    }
                }
            }

            // Count missed floating value
            for (let i = iValue; i <= 12; i++) {
                totalValue -= itemRow.columns[i].value;
            }
            if (totalValue > 0) {
                itemRow.columns[this.currentMonth].value = parseFloat((+itemRow.columns[this.currentMonth].value + totalValue).toFixed(numericDecimalPart));
            }
            if (itemRow.total.goalCategory === GoalCategoryEnum.Rating) {
                this.countTotal(itemRow);
            }
            this.countTotalDiff(itemRow);
        }

        countTotalDiff(itemRow: IGoalRowLine) {
            let value = itemRow.total.value,
                actualValue = itemRow.total.actualValue;

            itemRow.total.diff = value != 0 ? this.countDiff(value, actualValue) : NaN;
        }

        countDiff(value, actualValue) {
            let response = 0;

            if (value) {
                response = actualValue ? parseFloat((((actualValue || 0) * 100 / value) - 100).toFixed(this.inputNumericDecimalPart)) : NaN;
            }

            return response;
        }

        public getYearList(): void {
            this.busyService.start();
            this.dataService.customMethodData(`${this.appSettings.API_ROOT}/Tenant/Businessinfo`, 'GET', null).then((res: any) => {

                this.locationStartYear = res.data && res.data.implementationDate ? moment(res.data.implementationDate).year() : this.currentYear - 1;

                let i = this.locationStartYear;
                while (i <= (this.currentYear + 1)) {

                    let year = {
                        id: i,
                        label: i
                    };
                    this._yearSelect.push(year);
                    i++;
                }
            this._yearSelect = this._yearSelect.reverse();

                this.busyService.stop();
            });
        }
    }
}
